
export const environment = {
    production: false,
    supabaseUrl: 'https://boxrqldzghexczxjzhnk.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJveHJxbGR6Z2hleGN6eGp6aG5rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM2NzkwNTksImV4cCI6MjA0OTI1NTA1OX0.zrLnWuQcN3GRpO-kp-eZwt5dlMu3RcDcjxURG4v35Xs',
  };
  